import React, { useState, useEffect, useRef } from 'react';
import 'video.js/dist/video-js.css';
import TR from './../../Trans';
import LinearProgressWithLabel from '../items/LinearProgressWithLabel';
import Grid from '@mui/material/Grid';
import { getUrlForRelative } from '../../services/url';
import { useCast } from './../../cast/CastProvider';
import { useInView } from "react-intersection-observer";
import Popover from '@mui/material/Popover';
import ExternalScreenMove from '../dialogs/ExternalScreenMove';
import PlayerLinearProgressWithLabel from '../items/PlayerLinearProgressWithLabel';
import FixedPlayerButtons from '../items/FixedPlayerButtons';
import { checkIfMobile } from '../../services/screen';
import { Chromecast } from '@gameleap/capacitor-chromecast';
import { useMediaQuery } from 'react-responsive';
import InfoDialog from '../dialogs/InfoDialog';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import IntervalService from './../../services/intervals';
import SvgIcon from '@mui/material/SvgIcon';
import { VideoPlayer } from './VideoPlayer';
import { PreviewPlayer } from './PreviewPlayer';
import { MockPlayer } from './MockPlayer';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import ToggleButton from '@mui/material/ToggleButton';
import ExternalView from './ExternalView';
import CastIcon from '@mui/icons-material/Cast';
import { ReactComponent as PrevIcon } from './../../assets/prev.svg';
import { ReactComponent as PlayIcon } from './../../assets/play.svg';
import { ReactComponent as PauseIcon } from './../../assets/pause.svg';
import { ReactComponent as NextIcon } from './../../assets/next.svg';
import { ReactComponent as Replay10Icon } from './../../assets/replay10.svg';
import { ReactComponent as Forward10Icon } from './../../assets/forward10.svg';
import { ReactComponent as VolumeIcon } from './../../assets/volume.svg';
import { ReactComponent as MutedIcon } from './../../assets/muted.svg';
import { ReactComponent as VideoExtOpenIcon } from './../../assets/video-ext-open.svg';
import { ReactComponent as VideoExtCloseIcon } from './../../assets/video-ext-close.svg';
import { ReactComponent as FullscreenIcon } from './../../assets/fullscreen.svg';
import { ReactComponent as VideoSizeBigIcon } from './../../assets/video-size-large.svg';
import { ReactComponent as VideoSizeSmallIcon } from './../../assets/video-size-small.svg';
import { ReactComponent as VocIcon } from './../../assets/voc.svg';
import { ReactComponent as AutoplayIcon } from './../../assets/autoplay.svg';
import { ReactComponent as JumpToMusicIcon } from './../../assets/jump-to-music.svg';
import { ReactComponent as KeyUpDownIcon } from './../../assets/key-updown.svg';
import { getOS, getPlatform, isIPhone, isPossiblyIPad, isChromecast } from '../../services/os';
import MediaQuery from 'react-responsive';
import Tooltip from '@mui/material/Tooltip';
import NewWindow from 'react-new-window';
import ExternalScreen from 'cordova-plugin-wkwebview-external-screen';
import { Capacitor } from '@capacitor/core';
import StrService from './../../services/str';
import ExternalViewCommands from './../../services/external';
import sessionStore from './../../stores/session';
import playerStore from './../../stores/player';
import performanceStore from '../../stores/performance';
import navigationStore from '../../stores/navigation';
import newTracksStore from './../../stores/newTracks';
import messageStore from '../../stores/message';
import accountStore from '../../stores/account';
import musicStore from '../../stores/music';
import musicPlayerStore from '../../stores/musicPlayer';
import settingsStore from '../../stores/settings';
import statusStore from './../../stores/status';
import MediaScreen from './MediaScreen';
import { window } from 'global/window';
import { AndroidExternalScreen } from 'muvika-android-external-screen';
import muvikaAttrs from './../../attrs';
import MacExternalInfo from '../dialogs/MacExternalInfo';

function Player(props) {
  const playerRef = React.useRef(null);

  const sessionToken = sessionStore((state) => state.sessionToken);
  const safeArea = navigationStore((state) => state.safeArea);
  const setIsPlaying = playerStore((state) => state.setIsPlaying);
  const setFrom = playerStore((state) => state.setFrom);
  const setFullScreen = playerStore((state) => state.setFullScreen);
  const setMessage = messageStore((state) => state.setMessage);
  const isFullScreen = playerStore((state) => state.isFullScreen);
  const currentTrack = playerStore((state) => state.currentTrack);
  //const currentTime = playerStore((state) => state.currentTime);
  //const currentTime = 0;
  const history = performanceStore((state) => state.history);
  const getStreamUrl = playerStore((state) => state.getStreamUrl);
  const getNextPerformance = performanceStore((state) => state.getNextPerformance);
  const deletePerformance = performanceStore((state) => state.deletePerformance);
  const setCurrentTime = playerStore((state) => state.setCurrentTime);
  const addPerformanceToHistory = performanceStore((state) => state.addPerformanceToHistory);
  const currentPerformance = performanceStore((state) => state.currentPerformance);
  const nextPerformance = performanceStore((state) => state.nextPerformance);
  const currentPitch = playerStore((state) => state.currentPitch);
  const currentVersion = playerStore((state) => state.currentVersion);
  const setCurrentPitch = playerStore((state) => state.setCurrentPitch);
  const setCurrentVersion = playerStore((state) => state.setCurrentVersion);
  const isInExternalWindow = playerStore((state) => state.isInExternalWindow);
  const setIsInExternalWindow = playerStore((state) => state.setIsInExternalWindow);
  const isInIosExternalScreen = playerStore((state) => state.isInIosExternalScreen);
  const setIsInIosExternalScreen = playerStore((state) => state.setIsInIosExternalScreen);
  const isInAndroidExternalScreen = playerStore((state) => state.isInAndroidExternalScreen);
  const setIsInAndroidExternalScreen = playerStore((state) => state.setIsInAndroidExternalScreen);
  const currentVolume = playerStore((state) => state.currentVolume);
  const setIsCasting = playerStore((state) => state.setIsCasting);
  const setVolume = playerStore((state) => state.setVolume);
  const isPlaying = playerStore((state) => state.isPlaying);
  //const countdown = performanceStore((state) => state.countdown);
  const from = playerStore((state) => state.from);
  const isFocused = playerStore((state) => state.isFocused);
  const streamUrl = playerStore((state) => state.streamUrl);
  const setIsFocused = playerStore((state) => state.setIsFocused);
  const isPlayListOn = performanceStore((state) => state.isOn);
  const playQueue = performanceStore((state) => state.playQueue);
  const latest = newTracksStore((state) => state.latest);
  const getLatest = newTracksStore((state) => state.getLatest);
  const newTracks = newTracksStore((state) => state.tracks);
  const account = accountStore((state) => state.account);
  const getAccount = accountStore((state) => state.getAccount);
  const setError = messageStore((state) => state.setError);
  const getSettings = settingsStore((state) => state.getSettings);
  const setCurrentTrack = playerStore((state) => state.setCurrentTrack);
  const isStopped = playerStore((state) => state.isStopped);
  const setIsStopped = playerStore((state) => state.setIsStopped);
  const urls = accountStore((state) => state.urls);
  const setIsAutoPlayOn = playerStore((state) => state.setIsAutoPlayOn);
  const playQueueTrackList = performanceStore((state) => state.playQueueTrackList);
  const currentTitle = performanceStore((state) => state.currentTitle);
  const nextSingerTitle = performanceStore((state) => state.nextSingerTitle);
  const setAppStatus = statusStore((state) => state.setAppStatus);
  const setPlayerStatus = statusStore((state) => state.setPlayerStatus);
  const prevFromHistory = performanceStore((state) => state.prevFromHistory);
  const settings = settingsStore((state) => state.settings);
  const setSettings = settingsStore((state) => state.setSettings);
  const isSmallVideo = playerStore((state) => state.isSmallVideo);
  const setIsSmallVideo = playerStore((state) => state.setIsSmallVideo);
  const currentBuffer = playerStore((state) => state.currentBuffer);
  const isExternalWindowAvailable = playerStore((state) => state.isExternalWindowAvailable);
  const setIsExternalWaiting = playerStore((state) => state.setIsExternalWaiting);
  const isCastAvailable = playerStore((state) => state.isCastAvailable);
  const isCasting = playerStore((state) => state.isCasting);
  const setIsRequestingCasting = playerStore((state) => state.setIsRequestingCasting);
  const isRequestingCasting = playerStore((state) => state.isRequestingCasting);
  const isWaitingCasting = playerStore((state) => state.isWaitingCasting);
  const setIsWaitingCasting = playerStore((state) => state.setIsWaitingCasting);
  const setIsBuffering = playerStore((state) => state.setIsBuffering);
  const setCurrentPerformancePitch = performanceStore((state) => state.setCurrentPerformancePitch);
  const setAlwaysMoveToExternalScreen = sessionStore((state) => state.setAlwaysMoveToExternalScreen);
  const isMoveToExternalScreen = sessionStore((state) => state.isMoveToExternalScreen);
  const setApiWindowPerm = sessionStore((state) => state.setApiWindowPerm);
  const setPaddingBottom = navigationStore((state) => state.setPaddingBottom);
  const setIsFirstRender = navigationStore((state) => state.setIsPlayerFirstRender);
  const setIsReady = playerStore((state) => state.setIsReady);
  const isReady = playerStore((state) => state.isReady);
  const setIsSwitching = playerStore((state) => state.setIsSwitching);
  const isSwitching = playerStore((state) => state.isSwitching);
  const iosFrom = playerStore((state) => state.iosFrom);
  const setIosFrom = playerStore((state) => state.setIosFrom);
  const isMusicReallyPaused = musicPlayerStore((state) => state.isMusicReallyPaused);

  const [isMacExternalInfoOpen, setIsMacExternalInfoOpen] = useState(false);

  const handleOpenMacExternalInfo = () => {
    setIsMacExternalInfoOpen(true);
  };

  const handleCloseMacExternalInfo = () => {
    setIsMacExternalInfoOpen(false);
  };

  const [externalWindowHandle, setExternalWindowHandle] = useState(null);
  const { chromecast } = useCast();

  const playerElementRef = useRef(null);

  useEffect(() => {
    handleResize();
  }, [currentTrack]);

  const verticalButtonsRef = useRef(null);
  const topContainerRef = useRef(null);

  const videoJsOptions = {
    autoplay: false,
    controls: false,
    poster: "./poster.png",
    controlBar: {
      pictureInPictureToggle: false,
      currentTimeDisplay: true
    },
    experimentalSvgIcons: true,
    responsive: false,
    fluid: false,
    width: "100%",
    height: "100%",

  };

  const fixedPlayerButtons = useRef(null);
  const [playerButtonsRef, playerButtonsVisible, entry] = useInView({
    /* Optional options */
    threshold: 0,
  });

  const handleFixedPlayerButtons = () => {
    let buttonsElement = document.getElementById("muvika-fixed-player-buttons");
    if (buttonsElement) {
      let containerElement = document.getElementById("muvika-player-container");
      if (containerElement) {
        buttonsElement.style.display = playerButtonsVisible ? "none" : "flex";
      }
    }
  };

  const resizeFixedPlayerButtons = () => {
    let buttonsElement = document.getElementById("muvika-fixed-player-buttons");
    if (buttonsElement) {
      let containerElement = document.getElementById("muvika-player-container");
      if (containerElement) {
        if (checkIfMobile()) {
          buttonsElement.style.width = containerElement.offsetWidth + "px";
          buttonsElement.style.left = containerElement.offsetLeft + "px";
        } else {
          buttonsElement.style.width = containerElement.offsetWidth - 24 + "px";
          buttonsElement.style.left = containerElement.offsetLeft + "px";
        }
      }
    }
  };

  useEffect(() => {
    handleFixedPlayerButtons();
    resizeFixedPlayerButtons();
  }, [playerButtonsVisible]);

  useEffect(() => {
    setPaddingBottom("muvika-performances-list", -35);
  }, [isSmallVideo]);

  const [isExternalScreenMoveOpen, setIsExternalScreenMoveOpen] = useState(false);

  const handleOpenExternalScreenMove = () => {
    setIsExternalScreenMoveOpen(true);
  };

  const handleCloseExternalScreenMove = () => {
    setAlwaysMoveToExternalScreen(false);
    setIsExternalScreenMoveOpen(false);
  };

  const handleAlwaysMoveToExternalScreen = (isMove) => {
    console.log("move", isMove);
    setAlwaysMoveToExternalScreen(isMove);
    setIsPlaying(false);
    setAppStatus(sessionToken, "externalwindow");
    setIsInExternalWindow(!isInExternalWindow);
    setIsMacExternalInfoOpen(false);
    setIsExternalScreenMoveOpen(false);
  };

  const [isExternalInfoDialogOpen, setIsExternalInfoDialogOpen] = useState(false);

  const handleOpenExternalInfoDialog = () => {
    setIsExternalInfoDialogOpen(true);
  };

  const handleCloseExternalInfoDialog = () => {
    setIsExternalInfoDialogOpen(false);
  };

  const [isFullscreenInfoDialogOpen, setIsFullscreenInfoDialogOpen] = useState(false);

  const handleOpenFullscreenInfoDialog = () => {
    setIsFullscreenInfoDialogOpen(true);
  };

  const handleCloseFullscreenInfoDialog = () => {
    setIsFullscreenInfoDialogOpen(false);
  };

  const isMobile = useMediaQuery({ query: '(max-width: 720px)' });

  const handleVerticalButtonsPos = () => {
    let playerElement = document.getElementById("muvika-player-part");
    let buttonsElement = document.getElementById("muvika-player-vertical-buttons");
    let containerElement = document.getElementById("muvika-player-container");
    if (playerElement && buttonsElement && containerElement) {
      let posX = ((playerElement.offsetLeft - containerElement.offsetLeft) + playerElement.offsetWidth) - 37 - 29 + 16;
      let posY = ((-playerElement.offsetHeight - buttonsElement.offsetHeight) / 2) + 10;
      buttonsElement.style.top = posY + "px";
      buttonsElement.style.left = posX + "px";
      containerElement.style.height = (playerElement.offsetHeight + 40) + "px";
    }
  };

  const handleResize = () => {
    setTimeout(() => {
      let gridPart = document.getElementById("muvika-grid-player-part");
      let playerPart = document.getElementById("muvika-player-part");
      let performances = document.getElementById("muvika-performances");
      if (playerPart && gridPart && performances) {
        //playerPart.style.width = ((performances.offsetTop - playerPart.offsetTop - 25) * 1.6) + 'px';
        playerPart.style.width = gridPart.offsetWidth + "px";
      }
      handleVerticalButtonsPos();
    }, 100);
    resizeFixedPlayerButtons();
  };

  const [anchorPitchEl, setAnchorPitchEl] = useState(null);
  const [isPitchMenuOpen, setPitchMenuOpen] = useState(false);

  const [anchorAudioEl, setAnchorAudioEl] = React.useState(null);
  const openAudioPopover = Boolean(anchorAudioEl);

  function alignVideoPartVertically() {
    const element = document.getElementById('muvika-player-video-part-element');

    if (!element || !element.parentElement) {
      return;
    }

    const parent = element.parentElement;

    const marginTop =
      (parent.clientHeight - element.offsetHeight) / 2;

    element.style.paddingTop = `${Math.max(0, marginTop)}px`;
  }

  useEffect(() => {
    window.addEventListener('resize', alignVideoPartVertically);
    window.addEventListener('load', alignVideoPartVertically);
    window.addEventListener('refitbuttons', alignVideoPartVertically);
    window.addEventListener('resize', handleResize);
    window.addEventListener('refitbuttons', handleResize);
    if (!latest) {
      getLatest(sessionToken, 50);
    }
    if (!account) {
      getAccount(sessionToken);
    }
    if (!settings) {
      getSettings(sessionToken);
    }
    handleResize();
    if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios') {
      if (isInIosExternalScreen) {
        ExternalViewCommands.invokeJSOnExternalView("window.setPlayerStore('{\"from\": {\"from\": " + playerStore.getState().currentTime + "}}')");
      }
    }
    setPaddingBottom("muvika-performances-list", -35);
    return () => {
      window.onbeforeunload = null;
    };
  }, []);

  useEffect(() => {
    if (isFocused) {
      setIsFullscreenInfoDialogOpen(false);
    }
  }, [isFocused]);

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    window.addEventListener('refitbuttons', handleResize);
    setPaddingBottom("muvika-performances-list", -35);
  }, [currentTrack]);

  useEffect(() => {
    if (settings) {
      if (settings.video_size === "large") {
        setIsSmallVideo(false);
      } else if (settings.video_size === "small") {
        setIsSmallVideo(true);
      }
    }
  }, [settings]);

  const handleClickAudio = (event) => {
    setAnchorAudioEl(event.currentTarget);
  };

  const handleCloseAudio = () => {
    setAnchorAudioEl(null);
  };

  const play = () => {
    if (isFocused && isReady && !isSwitching && streamUrl !== "") {
      setIsReady(false);
      if (currentPerformance && currentTrack) {
        console.log("currentTrack", isFocused, currentPerformance, currentTrack, streamUrl);
        IntervalService.clearAllIntervals();
        setIsPlaying(true);
        setIsStopped(false);
        if (streamUrl === "") {
          getStreamUrl(sessionToken, currentPerformance, currentTrack, currentPerformance.pitch, currentVersion, 0, true);
        }
      } else {
        if (streamUrl === "") {
          setIsStopped(false);
          getStreamUrl(sessionToken, currentPerformance, currentPerformance.track, currentPerformance.pitch, currentVersion, 0, true);
        }
      }
    }
  };

  const pause = () => {
    console.log("isReady pause");
    console.log("network error", isFocused, isReady, isSwitching, currentPerformance, currentTrack);
    if (isReady && !isSwitching) {
      setIsReady(false);
      setIsPlaying(false);
    }
  };

  const stop = () => {
    IntervalService.clearAllIntervals();
    if (!isStopped.isStopped) {
      setIsPlaying(false);
      setIsStopped(true);
      setCurrentTime(0);
    } else {
      setIsSwitching(false);
      setIsReady(true);
    }
    setFrom(0);
  };

  const toFullScreen = () => {
    setFullScreen(true);
  };

  const toAudio = () => {
    if (currentTrack) {
      setFrom(parseFloat(currentTrack.audio_start));
    }
  };

  const toggleVocal = () => {
    if (currentVersion === "vocal") {
      setCurrentVersion("normal");
    } else {
      setCurrentVersion("vocal");
    }
  };

  const handleProgressClick = (event) => {
    const player = playerRef.current;
    if (currentTrack) {
      let rect = event.currentTarget.getBoundingClientRect();
      const x = ((event.clientX - rect.left) * currentTrack.length.split(':').reduce((acc, time) => (60 * acc) + +time)) / event.currentTarget.offsetWidth;
      setFrom(x);
    }
  };

  const currentProgress = () => {
    if (currentTrack && currentTrack.length) {
      return (playerStore.getState().currentTime / currentTrack.length.split(':').reduce((acc, time) => (60 * acc) + +time)) * 100;
    } else {
      return 0;
    }
  };

  const lengthToMinutes = (length) => {
    if (length) {
      const splitted = length.split(":");
      if (splitted.length == 3) {
        return splitted[1] + ":" + splitted[2];
      }
    }
  };

  const toMMSS = (secs) => {
    var sec_num = parseInt(secs, 10);
    var hours = Math.floor(sec_num / 3600);
    var minutes = Math.floor(sec_num / 60) % 60;
    var seconds = sec_num % 60;

    return [hours, minutes, seconds]
      .map(v => v < 10 ? "0" + v : v)
      .filter((v, i) => v !== "00" || i > 0)
      .join(":");
  };

  const getLength = (track) => {
    if (track) {
      return lengthToMinutes(track.length);
    }
    return "";
  };

  const handlePitchMenuOpen = () => {
    setPitchMenuOpen(true);
  };

  const handlePitchMenuClose = () => {
    setPitchMenuOpen(false);
  };

  const openPitchMenu = (event) => {

    setAnchorPitchEl(event.currentTarget);
    setPitchMenuOpen(true);
  };

  const changeCurrentPitch = (pitch) => {
    console.log("test get stream url r", pitch, currentPerformance.pitch);
    if (currentPerformance) {
      if (currentPerformance.pitch !== pitch) {
        setCurrentPitch(pitch);
        setCurrentPerformancePitch(sessionToken, pitch);
      }
    }
    setPitchMenuOpen(false);
  };

  const isVocalAvailable = () => {
    if (currentTrack) {
      if (currentTrack.flags) {
        return currentTrack.flags.includes("voc_avail");
      }
    }
    return false;
  };

  const createNewTracksTitleStr = () => {
    let newTracksTitle = "";
    if (newTracksStore.getState().tracks) {
      let newTracksSlice = newTracksStore.getState().tracks.slice(0, 20);
      let length = newTracksSlice.length;
      for (let i = 0; i < length; i++) {
        let item = newTracksSlice[i];
        newTracksTitle += item.artist + " - " + item.title + "#";
      }
    }
    newTracksTitle = newTracksTitle.replace(/"/g, '');
    return newTracksTitle;
  };

  const sendDataToExternal = () => {
    //ExternalViewCommands.invokeJSOnExternalView("window.setNewTracksStore('{\"newTracksTitle\": \"" + createNewTracksTitleStr() + "\"}')");
    ExternalViewCommands.invokeJSOnExternalView("window.setNewTracksTitle(\"" + createNewTracksTitleStr() + "\")");
    ExternalViewCommands.invokeJSOnExternalView("window.setPerformanceStore('{\"countdown\": " + performanceStore.getState().countdown + "}')");
    ExternalViewCommands.invokeJSOnExternalView("window.setPerformanceStore('{\"currentPerformance\": " + JSON.stringify(performanceStore.getState().currentPerformance) + "}')");
    ExternalViewCommands.invokeJSOnExternalView("window.setPerformanceStore('{\"nextPerformance\": " + JSON.stringify(performanceStore.getState().nextPerformance) + "}')");
    ExternalViewCommands.invokeJSOnExternalView("window.setPerformanceStore('{\"playQueue\": " + JSON.stringify(performanceStore.getState().playQueue) + "}')");
    //ExternalViewCommands.invokeJSOnExternalView("window.setNewTracksStore('{\"tracks\": " + JSON.stringify(newTracksStore.getState().tracks) + "}')");
    ExternalViewCommands.invokeJSOnExternalView("window.setPlayerStore('{\"isPlaying\": {\"isPlaying\": " + playerStore.getState().isPlaying.isPlaying + "}}')");
    ExternalViewCommands.invokeJSOnExternalView("window.setPlayerStore('{\"isStopped\": {\"isStopped\": " + playerStore.getState().isStopped.isStopped + "}}')");
    ExternalViewCommands.invokeJSOnExternalView("window.setPlayerStore('{\"streamUrl\": \"" + playerStore.getState().streamUrl + "\"}')");
    ExternalViewCommands.invokeJSOnExternalView("window.setPlayerStore('{\"currentVolume\": {\"currentVolume\":" + playerStore.getState().currentVolume.currentVolume + "}}')");
    if (!(Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios' && !playerStore.getState().hasBeenPlayed)) {
      ExternalViewCommands.invokeJSOnExternalView("window.setPlayerStore('{\"from\": {\"from\": " + playerStore.getState().currentTime + "}}')");
    }
    if (playerStore.getState().iosFrom?.from) {
      ExternalViewCommands.invokeJSOnExternalView("window.setPlayerStore('{\"iosFrom\": {\"from\": " + playerStore.getState().iosFrom?.from + "}}')");
    }
    ExternalViewCommands.invokeJSOnExternalView("window.setAccountStore('{\"account\": " + JSON.stringify(accountStore.getState().account) + "}')");
    ExternalViewCommands.invokeJSOnExternalView("window.setSettingsStore('{\"settings\": " + JSON.stringify(settingsStore.getState().settings) + "}')");
    ExternalViewCommands.invokeJSOnExternalView("window.setAccountStore('{\"urls\": " + JSON.stringify(accountStore.getState().urls) + "}')");
    ExternalViewCommands.invokeJSOnExternalView("window.setPerformanceStore('{\"playQueueTrackList\": \"" + performanceStore.getState().playQueueTrackList + "\"}')");
    ExternalViewCommands.invokeJSOnExternalView("window.setPerformanceStore('{\"currentTitle\": \"" + performanceStore.getState().currentTitle + "\"}')");
    ExternalViewCommands.invokeJSOnExternalView("window.setPerformanceStore('{\"nextSingerTitle\": \"" + performanceStore.getState().nextSingerTitle + "\"}')");
    ExternalViewCommands.invokeJSOnExternalView("window.setMusicPlayerStore('{\"isMusicOn\": " + musicPlayerStore.getState().isMusicOn + "}')");
    ExternalViewCommands.invokeJSOnExternalView("window.setMusicPlayerStore('{\"isMusicReallyPaused\": {\"isPaused\": " + musicPlayerStore.getState().isMusicReallyPaused.isPaused + "}}')");
  };

  const initIosExternalScreen = () => {
    setExternalVideoWidth();
    sendDataToExternal();
    setIsInIosExternalScreen(true);
  };

  const initAndroidExternalScreen = () => {
    sendDataToExternal();
    setIsInAndroidExternalScreen(true);
  };

  const setExternalVideoWidth = () => {
    ExternalScreen.getScreenWidth(function (width) {
      //console.log("external ios screen width: " + width);
      ExternalViewCommands.invokeJSOnExternalView("window.setPlayerStore('{\"iosExternalScreenWidth\": " + width + "}')");
    });
  };

  const loadToIosExternalScreen = () => {
    setIsExternalWaiting(true);
    ExternalScreen.checkAvailability(function (isAvailable) {
      if (isAvailable) {
        const exUrl = accountStore.getState().urls.url_ext_screen;
        StrService.get(exUrl, {})
          .then(function (res) {
            ExternalScreen.loadHTML(exUrl, res.data, function (result) {
              console.log("ios event: " + JSON.stringify(result));
              if (result.length == 2) {
                if (result[1].length == 1) {
                  switch (result[0]) {
                    case "CURRENT_TIME":
                      if (playerStore.getState().isInIosExternalScreen) {
                        playerStore.getState().setIsSwitching(false);
                        playerStore.getState().setIsReady(true);
                        playerStore.getState().setCurrentTime(result[1][0]);
                      }
                      break;
                    case "IS_BUFFERING":
                      if (playerStore.getState().isInIosExternalScreen)
                        playerStore.getState().setIsBuffering(result[1][0]);
                      break;
                  }
                }
              }
            });
            setTimeout(function () {
              initIosExternalScreen();
              setIsExternalWaiting(false);
            }, 1500);
          });
      }
    });
  };

  const loadToAndroidExternalScreen = () => {
    setIsExternalWaiting(true);
    AndroidExternalScreen.checkAvailability().then((res) => {
      if (res.value) {
        const exUrl = accountStore.getState().urls.url_ext_screen;
        console.log("externalUrl", exUrl);
        StrService.get(exUrl, {})
          .then(function (res) {
            AndroidExternalScreen.loadHTML({ baseUrl: exUrl, html: res.data });
            setTimeout(function () {
              initAndroidExternalScreen();
              setIsExternalWaiting(false);
            }, 1500);
          });
      }
    });
  };

  const loadBasicToIosExternalScreen = () => {
    ExternalScreen.checkAvailability(function (isAvailable) {
      if (isAvailable) {
        const exUrl = accountStore.getState().urls.url_ext_screen;
        const exUrlBasic = exUrl + "basic/";
        StrService.get(exUrlBasic, {})
          .then(function (res) {
            ExternalScreen.loadHTML(exUrl, res.data);
          });
      } else {
        ExternalScreen.checkOut();
      }
    });
  };

  const loadBasicToAndroidExternalScreen = () => {
    AndroidExternalScreen.checkAvailability().then((res) => {
      if (res.value) {
        const exUrl = accountStore.getState().urls.url_ext_screen;
        console.log("externalUrl", exUrl);
        const exUrlBasic = exUrl + "basic/";
        StrService.get(exUrlBasic, {})
          .then(function (res) {
            AndroidExternalScreen.loadHTML({ baseUrl: exUrl, html: res.data });
          });
      } else {
      }
    });
  };

  function handleNonNativeExternalWindow() {
    if (!isInExternalWindow) {
      //IntervalService.clearAllIntervals();
      if ('getScreenDetails' in window) {
        window.getScreenDetails()
          .then((details) => {
            console.log("external", details);
            setApiWindowPerm(true);
            if (details) {
              let currentScreen = details.currentScreen;
              console.log("external", details.screens.length);
              if (details.screens.length > 1 && currentScreen.isPrimary) {
                let extendedScreen = details.screens.filter((screen) => !screen.isPrimary && screen.isExtended)[0];
                if (extendedScreen) {
                  handleOpenExternalScreenMove();
                } else {
                  setIsPlaying(false);
                  IntervalService.clearAllIntervals();
                  setAppStatus(sessionToken, "externalwindow");
                  setIsInExternalWindow(!isInExternalWindow);
                  setIsMacExternalInfoOpen(false);
                  setIsExternalScreenMoveOpen(false);
                }
              } else {
                setIsPlaying(false);
                IntervalService.clearAllIntervals();
                setAppStatus(sessionToken, "externalwindow");
                setIsInExternalWindow(!isInExternalWindow);
                setIsMacExternalInfoOpen(false);
                setIsExternalScreenMoveOpen(false);
              }
            }
          })
          .catch(() => {
            setIsPlaying(false);
            IntervalService.clearAllIntervals();
            setAppStatus(sessionToken, "externalwindow");
            setIsInExternalWindow(!isInExternalWindow);
            setIsMacExternalInfoOpen(false);
            setError(sessionToken, 0, TR.cm_window_perms);
          });
      } else {
        setIsPlaying(false);
        IntervalService.clearAllIntervals();
        setAppStatus(sessionToken, "externalwindow");
        setIsInExternalWindow(!isInExternalWindow);
        setIsMacExternalInfoOpen(false);
      }
      window.onbeforeunload = function () {
        setIsInExternalWindow(false);
        return null;
      };
    } else {
      window.onbeforeunload = null;
      setAppStatus(sessionToken, "mainwindow");
      setIsInExternalWindow(!isInExternalWindow);
      setIsMacExternalInfoOpen(false);
    }
  };

  function toExternalWindow() {
    if (Capacitor.getPlatform() === 'ios') {
      if (!isInIosExternalScreen) {
        IntervalService.clearAllIntervals();
        setIsPlaying(false);
        setMessage(sessionToken, TR.cm_wait);
        loadToIosExternalScreen();
      } else {
        setIsInIosExternalScreen(false);
        setIsInExternalWindow(false);
        loadBasicToIosExternalScreen();
      }
    }
    if (Capacitor.getPlatform() === 'android') {
      if (!isInAndroidExternalScreen) {
        IntervalService.clearAllIntervals();
        setIsPlaying(false);
        setMessage(sessionToken, TR.cm_wait);
        loadToAndroidExternalScreen();
      } else {
        setIsInAndroidExternalScreen(false);
        setIsInExternalWindow(false);
        loadBasicToAndroidExternalScreen();
      }
    }
    if (!Capacitor.isNativePlatform()) {
      if (isPossiblyIPad()) {
        if (!isInExternalWindow) {
          handleOpenMacExternalInfo();
        } else {
          setIsInExternalWindow(!isInExternalWindow);
          setIsMacExternalInfoOpen(false);
        }
      } else {
        handleNonNativeExternalWindow();
      }
    }
  };

  const renderPreviewPlayer = () => {
    return <PreviewPlayer
      className="muvika-player-video"
      options={videoJsOptions}
      isCustomer={account ? account.tags.includes("consumer") : false}
    />;
  };

  const renderPlayer = () => {
    return <VideoPlayer
      className="muvika-player-video"
      options={videoJsOptions}
      isCustomer={account ? account.tags.includes("consumer") : false}
    />;
  };

  const player = () => {
    if (account && settings) {
      if (isInExternalWindow) {
        return <div>
          <NewWindow
            className="muvika-player-external"
            name="muvika-external-player"
            onOpen={async (newWindow) => {
              if ('getScreenDetails' in window) {
                newWindow.addEventListener('keydown', (e) => {
                  setIsFocused(true);
                });
                let currentScreen;
                if (isMoveToExternalScreen) {
                  console.log("move", isMoveToExternalScreen);
                  window.getScreenDetails()
                    .then(details => {
                      if (details) {
                        currentScreen = details.currentScreen;
                        if (details.screens.length > 1 && currentScreen.isPrimary) {
                          let extendedScreen = details.screens.filter((screen) => !screen.isPrimary && screen.isExtended)[0];
                          if (extendedScreen) {
                            setIsFullscreenInfoDialogOpen(true);
                            newWindow.moveTo(extendedScreen.left, 0);
                            document.body.requestFullscreen({ navigationUI: "hide", screen: extendedScreen });
                          }
                        }
                      }
                    })
                    .catch(() => {
                      IntervalService.clearAllIntervals();
                      setError(sessionToken, 0, TR.cm_window_perms);
                    });
                }
              }
              IntervalService.clearAllIntervals();
              setExternalWindowHandle(newWindow);
              setIsPlaying(false);
              setIsFocused(false);
              setIsInExternalWindow(true);
              setFrom(playerStore.getState().currentTime);
            }}
            onUnload={() => {
              setIsPlaying(false);
              setIsFocused(true);
              setIsInExternalWindow(false);
              setFrom(playerStore.getState().currentTime);
              setAppStatus(sessionToken, "mainwindow");
            }}>
            <ExternalView isDesktop={true} />
          </NewWindow>
          {renderPreviewPlayer()}
        </div>;
      } else if (!isInIosExternalScreen && !isInAndroidExternalScreen && !isCasting) {
        return renderPlayer();
      } else if (isInIosExternalScreen || isInAndroidExternalScreen || isCasting) {
        return renderPreviewPlayer();
      }
    }
  };

  const handleVolumeClick = (event) => {
    let rect = event.currentTarget.getBoundingClientRect();
    const x = (event.clientX - rect.left) / event.currentTarget.offsetWidth;
    setVolume(x);
    if (settings) {
      let newSettings = { ...settings };
      newSettings.volume = Math.round(x * 100);
      setSettings(sessionToken, newSettings, false);
    }
  };

  const renderPauseOrPlay = () => {
    if (isPlaying.isPlaying) {
      return <Tooltip title={TR.cm_pause}>
        <IconButton className="muvika-player-button" color="white" component="label" size="small" onClick={() => {
          pause();
        }}>
          <SvgIcon className="muvika-icon" component={PauseIcon} />
        </IconButton>
      </Tooltip>;
    } else {
      return <Tooltip title={TR.cm_play}>
        <IconButton className="muvika-player-button" color="white" component="label" size="small" onClick={() => {
          play();
        }}>
          <SvgIcon className="muvika-icon" component={PlayIcon} />
        </IconButton>
      </Tooltip>;
    }
  };

  const renderProgressLine = () => {
    if (currentTrack) {
      return <PlayerLinearProgressWithLabel onProgressClick={handleProgressClick} />;
      //return <LinearProgressWithLabel currentTime={toMMSS(playerStore.getState().currentTime)} value={currentProgress()} buffer={currentBuffer * 100} length={getLength(currentTrack)} onProgressClick={handleProgressClick} />;
    }
  };

  const renderVolIcon = () => {
    if (currentVolume.currentVolume > 0) {
      return <SvgIcon className="muvika-icon" component={VolumeIcon} />;
    } else {
      return <SvgIcon className="muvika-icon" component={MutedIcon} />;
    }
  };

  const renderAudioButtonIfNotIos = () => {
    if ((!isIPhone() && !isPossiblyIPad()) || Capacitor.isNativePlatform()) {
      return <Tooltip title={TR.cm_volume}>
        <IconButton className="muvika-player-button" color="white" component="label" size="small" onClick={handleClickAudio}>
          {renderVolIcon()}
        </IconButton>
      </Tooltip>;
    }
  };

  const toggleAutoplay = () => {
    if (settings) {
      setIsFirstRender(false);
      let newSettings = { ...settings };
      newSettings.autoplay_enabled = !settings.autoplay_enabled;
      setSettings(sessionToken, newSettings);
    }
  };

  const next = () => {
    console.log("isReady next");
    if (!isSwitching && isReady) {
      setIsReady(false);
      setFrom(0);
      setTimeout(() => {
        setIsSwitching(true);
        setIsAutoPlayOn(true);
        stop();
        addPerformanceToHistory(sessionToken, currentPerformance);
        deletePerformance(sessionToken, currentPerformance.unique_id);
        if (isPlayListOn) {
          let nextPerformance = getNextPerformance();
          if (nextPerformance) {
            getStreamUrl(sessionToken, nextPerformance, nextPerformance.track, nextPerformance.pitch, currentVersion);
          }
        }
      }, 50);
    }
  };

  const prev = () => {
    console.log("isReady prev");
    if (!isSwitching && isReady) {
      setIsReady(false);
      setIsAutoPlayOn(true);
      playerStore.getState().setIsTrackLogSent(null);
      let currentTimeNow = playerStore.getState().currentTime;
      stop();
      console.log("stop", currentTimeNow);
      if (history.items.length > 0) {
        if (currentTimeNow == 0) {
          console.log("stop", currentTimeNow);
          setIsSwitching(true);
          prevFromHistory(sessionToken);
        }
      }
    }
  };

  const backwards10 = () => {
    if (iosFrom?.from) {
      setFrom(iosFrom?.from - 10);
    } else {
      setFrom(playerStore.getState().currentTime - 10);
    }
  };

  const forwards10 = () => {
    if (iosFrom?.from) {
      setFrom(iosFrom?.from + 10);
    } else {
      setFrom(playerStore.getState().currentTime + 10);
    }
  };

  const renderPrevButton = () => {
    return <Tooltip title={TR.cm_previous}>
      <ToggleButton disabled={isSwitching} className="muvika-player-toggle-button" value="check" onClick={prev}>
        <SvgIcon className="muvika-icon" component={PrevIcon} />
      </ToggleButton>
    </Tooltip>;
  };

  const renderNextButton = () => {
    return <Tooltip title={TR.cm_next}>
      <IconButton disabled={isSwitching} className="muvika-player-button" color="white" component="label" size="small" onClick={next}>
        <SvgIcon className="muvika-icon" component={NextIcon} />
      </IconButton>
    </Tooltip>;
  };

  const renderReplayButton = () => {
    return <Tooltip title={TR.cm_rewind_10s}>
      <ToggleButton className="muvika-player-toggle-button" value="check" onClick={backwards10}>
        <SvgIcon className="muvika-icon" component={Replay10Icon} />
      </ToggleButton>
    </Tooltip>;
  };

  const renderForwardButton = () => {
    return <Tooltip title={TR.cm_forward_10s}>
      <ToggleButton className="muvika-player-toggle-button" value="check" onClick={forwards10}>
        <SvgIcon className="muvika-icon" component={Forward10Icon} />
      </ToggleButton>
    </Tooltip>;
  };

  const renderJumpButton = () => {
    return <Tooltip title={TR.cm_jump_to_music}>
      <IconButton className="muvika-player-button" color="white" component="label" size="small" onClick={() => {
        toAudio();
      }}>
        <SvgIcon className="muvika-icon" component={JumpToMusicIcon} />
      </IconButton>
    </Tooltip>;
  };

  const renderPitchButton = () => {
    let curPitch = 0;
    if (currentPerformance) {
      curPitch = currentPerformance.pitch > 0 ? "+" + currentPerformance.pitch : currentPerformance.pitch;
    }
    return <Tooltip title={TR.cm_key}>
      <IconButton className="muvika-player-toggle-button" color="white" component="label" size="small" onClick={openPitchMenu} disabled={isVocal()} >
        <SvgIcon className="muvika-icon" component={KeyUpDownIcon} />
        <span>{curPitch}</span>
      </IconButton>
    </Tooltip>;
  };

  const isVocal = () => {
    if (currentPerformance) {
      if (currentPerformance.track.flags) {
        if (currentPerformance.track.flags.includes("voc_avail") && currentVersion === "vocal") {
          return true;
        }
      }
    }
    return false;
  };

  const renderVocButton = () => {
    return <Tooltip title={TR.cm_switch_vocal_version}>
      <ToggleButton className="muvika-player-toggle-button" value="check" selected={isVocal() || (currentVersion === "vocal" && (playQueue ? playQueue.items.length == 0 : false))} onChange={toggleVocal} disabled={!isVocalAvailable() && currentVersion === "normal" && (playQueue ? playQueue.items.length > 0 : false) ? true : false} >
        <SvgIcon className={"muvika-icon " + (settings ? (settings.voc_enabled == 1 ? "muvika-pulse " : " ") : " ") + (!isVocalAvailable() && currentVersion === "vocal" && (playQueue ? playQueue.items.length > 0 : false) ? "muvika-pulse-grey" : "")} component={VocIcon} />
      </ToggleButton>
    </Tooltip>;
  };

  const renderAutoplayButton = () => {
    return <Tooltip title={TR.cm_autoplay_next}>
      <ToggleButton className="muvika-player-toggle-button" value="check" selected={settings ? settings.autoplay_enabled == 1 : false} onChange={toggleAutoplay} >
        <SvgIcon className={"muvika-icon " + (settings ? (settings.autoplay_enabled == 1 ? "muvika-pulse" : "") : "")} component={AutoplayIcon} />
      </ToggleButton>
    </Tooltip>;
  };

  const renderExternalWindowButton = () => {
    if (!isCasting) {
      if (isExternalWindowAvailable) {
        if (!isInExternalWindow && !isInIosExternalScreen && !isInAndroidExternalScreen) {
          return <Tooltip title={TR.cm_detach_video}>
            <IconButton id="muvika-open-external-screen" className="muvika-player-button" color="white" component="label" size="small" onClick={() => {
              toExternalWindow();
            }}>
              <SvgIcon className="muvika-icon" component={VideoExtOpenIcon} />
            </IconButton>
          </Tooltip>;
        } else {
          return <Tooltip title={TR.cm_attach_video}>
            <IconButton id="muvika-close-external-screen" className="muvika-player-button" color="white" component="label" size="small" onClick={() => {
              toExternalWindow();
            }}>
              <SvgIcon className="muvika-icon" component={VideoExtCloseIcon} />
            </IconButton>
          </Tooltip>;
        }
      } else {
        if (Capacitor.isNativePlatform()) {
          return <Tooltip title={TR.cm_detach_video}>
            <IconButton sx={{ color: "rgb(100,100,100)" }} className="muvika-player-button" component="label" size="small" onClick={() => {
              setIsExternalInfoDialogOpen(true);
            }}>
              <SvgIcon className="muvika-icon" component={VideoExtOpenIcon} />
            </IconButton>
          </Tooltip>;
        }
      }
    }
  };

  const renderFullscreenButton = () => {
    if (!isInExternalWindow && !isInIosExternalScreen && !isInAndroidExternalScreen && !isCasting) {
      return <Tooltip title={TR.cm_fullscreen}>
        <IconButton className="muvika-player-button" color="white" component="label" size="small" onClick={() => {
          toFullScreen();
        }}>
          <SvgIcon className="muvika-icon" component={FullscreenIcon} />
        </IconButton>
      </Tooltip>;
    }
  };

  const goToCasting = () => {
    if (!isWaitingCasting) {
      if (!Capacitor.isNativePlatform()) {
        console.log("try to cast");
        setIsWaitingCasting(true);
        chromecast.requestSession()
          .then(() => {
            setIsWaitingCasting(false);
          })
          .catch((err) => {
            console.log("chromecast", err);
            setIsWaitingCasting(false);
          });
      } else if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'android') {
        Chromecast.initialize()
          .then(result => {
            if (result) {
              Chromecast.requestSession()
                .then(result => {
                  if (result) {
                    setIsRequestingCasting(false);
                    setIsCasting(true);
                  }
                })
                .catch(err => {
                  console.log("casting error: ", err.message);
                  if (err.message === "timeout") {
                    setError(sessionToken, 0, TR.cm_chromecast_timeout);
                  }
                  setIsRequestingCasting(false);
                  setIsCasting(false);
                });
            }
          })
          .catch(err => {
            console.log(err);
            setIsRequestingCasting(false);
            setIsCasting(false);
          });
      }
    }
  };


  const toCasting = () => {
    if (isCasting) {
      setIsWaitingCasting(false);
      if (!Capacitor.isNativePlatform()) {
        chromecast.off();
        chromecast.disconnect();
      } else if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'android') {
        Chromecast.sessionStop()
          .then(result => {
            if (result) {
              setIsCasting(false);
            }
          })
          .catch(err => {
            console.log(err);
            setIsCasting(false);
          });
      }
    } else {
      IntervalService.clearAllIntervals();
      if (!isStopped.isStopped) {
        setFrom(0);
        setCurrentTime(0);
        setIsStopped(true);
        setIsPlaying(false);
      }
      goToCasting();
    }
  };

  const renderCastButton = () => {
    if (isCastAvailable && !isInExternalWindow && !isInIosExternalScreen && !isInAndroidExternalScreen) {
      return <Tooltip title={isCasting ? TR.cm_disable_chromecast : TR.cm_enable_chromecast}><ToggleButton className="muvika-player-toggle-button" value="check" selected={isCasting} component="label" size="small" onChange={() => {
        toCasting();
      }}>
        <CastIcon />
      </ToggleButton>
      </Tooltip>;
    }
  };

  const savePlayerSize = (size) => {
    let newSettings = { ...settings };
    newSettings.video_size = size;
    setSettings(sessionToken, newSettings, false);
  };

  const renderBigSmallButton = () => {
    if (isSmallVideo) {
      return <Tooltip title={TR.cm_large_video}>
        <IconButton className="muvika-player-button" color="white" component="label" size="small" onClick={() => {
          setIsSmallVideo(false);
          savePlayerSize("large");
          handleResize();
        }}>
          <SvgIcon className="muvika-icon" component={VideoSizeBigIcon} />
        </IconButton>
      </Tooltip>;
    } else {
      return <Tooltip title={TR.cm_small_video}>
        <IconButton className="muvika-player-button" color="white" component="label" size="small" onClick={() => {
          setIsSmallVideo(true);
          savePlayerSize("small");
          handleResize();
        }}>
          <SvgIcon className="muvika-icon" component={VideoSizeSmallIcon} />
        </IconButton>
      </Tooltip>;
    }
  };

  const renderExternalInfo = () => {
    if (isInExternalWindow || isInIosExternalScreen || isInAndroidExternalScreen || isCasting) {
      return <span className="muvika-player-external-info-span">{TR.cm_video_is_in_external_window}</span>;

    }
  };

  const calcWidth = () => {
    if (safeArea) {
      let minusWidth = safeArea ? safeArea.left + safeArea.right : 0;
      if (checkIfMobile()) {
        return isSmallVideo ? "calc(40vw*1.6 - " + minusWidth + "px)" : "calc(61vw*1.6 - " + minusWidth + "px)";
      } else {
        return isSmallVideo ? "calc(20vw*1.6 - " + minusWidth + "px)" : "calc(28vw*1.6 - " + minusWidth + "px)";
      }
    }
  };

  const calcButtonsWidth = () => {
    if (safeArea) {
      let minusWidth = safeArea ? safeArea.left + safeArea.right : 0;
      if (checkIfMobile()) {
        return "calc(31vw*1.6 - " + minusWidth + "px)";
      } else {
        return "calc(20vw*1.3 - " + minusWidth + "px)";
      }
    }
  };

  const calcGridXsTop = () => {
    if (checkIfMobile()) {
      return isSmallVideo ? 10 : 11;
    } else {
      return isSmallVideo ? 10 : 11;
    }
  };

  const calcGridXsBottom = () => {
    if (checkIfMobile()) {
      return isSmallVideo ? 2 : 1;
    } else {
      return isSmallVideo ? 1 : 1;
    }
  };

  const renderSplitter = () => {
    if (!checkIfMobile()) {
      return <div style={{ width: "2rem" }}></div>;
    }
  };

  const scrollParentToTop = (element) => {
    let parent = element.parentElement;
    while (parent) {
      parent.dataset.isHumanClick = true;
      parent.scrollTop = 1;
      parent = parent.parentElement;
    }
  };

  const renderWaitingForMusic = () => {
    if (!isMusicReallyPaused.isPaused) {
      return <div style={{ position: "relative" }}>
        <div className="muvika-karaoke-music-waiting-container">
          <span className="muvika-karaoke-music-waiting">
            {TR.cm_playing_background_music}
          </span>
        </div>
      </div>;
    }
  };

  const renderPlayerContainer = () => {
    if (account) {
      if (account.subscription.valid == 1) {
        return <div id="muvika-player-container">
          <MacExternalInfo
            open={isMacExternalInfoOpen}
            onClose={handleCloseMacExternalInfo}
            onOpen={handleNonNativeExternalWindow}
          />
          <FixedPlayerButtons
            id={"muvika-fixed-player-buttons"}
            direction="row"
            spacing={1}
            justifyContent="center"
            isPerformance={true}
            sx={{ paddingRight: safeArea ? safeArea.right + "px" : 0 }}
            image={currentPerformance?.track?.url_cover_image ? currentPerformance?.track?.url_cover_image : ""}
            primary={currentPerformance?.track?.artist}
            kcode={currentPerformance?.track?.kcode}
            length={lengthToMinutes(currentPerformance?.track?.length)}
            pitch={currentPerformance?.pitch}
            currentProgress={currentProgress()}
            onClick={(e) => {
              scrollParentToTop(e.target);
            }}
          />
          <div style={{ width: isMobile ? "100%" : "100%", margin: "auto" }}>
            <div ref={playerElementRef} id="muvika-player-part" className="muvika-player-video-part" style={{ width: isSmallVideo ? (isMobile ? "80%" : "60%") : "100%", paddingRight: "calc(2rem + 24px)", paddingLeft: "1rem", minHeight: "9.3rem" }} >
              <div id="muvika-player-video-part-element">
                {player()}
                {renderProgressLine()}
                {renderWaitingForMusic()}
              </div>
            </div>
            <div ref={playerButtonsRef} className="muvika-player-buttons" style={{ margin: "auto", position: "relative" }}>
              {renderExternalInfo()}
              <Stack direction="row" spacing={0.4} justifyContent="center">
                {renderPrevButton()}
                {renderPauseOrPlay()}
                {renderNextButton()}
                {renderReplayButton()}
                {renderForwardButton()}
                {renderJumpButton()}
                {renderSplitter()}
                {renderPitchButton()}
                {renderVocButton()}
                {renderAutoplayButton()}
                {renderAudioButtonIfNotIos()}
              </Stack>
            </div>
          </div>
          <div ref={verticalButtonsRef} id="muvika-player-vertical-buttons" style={{ position: "relative", maxWidth: "3rem" }}>
            <Stack
              alignItems="center"
              spacing={1}
              justifyContent="center"
              sx={{
                display: "flex",
                marginTop: "-2.5rem",
                alignItems: "center"
              }}
            >
              {renderCastButton()}
              {renderExternalWindowButton()}
              {renderFullscreenButton()}
              {renderBigSmallButton()}
            </Stack>
          </div>
          <Menu disableAutoFocus disableEnforceFocus disableRestoreFocus
            id={"player-edit-pitch"}
            open={isPitchMenuOpen}
            anchorEl={anchorPitchEl}
            onClose={handlePitchMenuClose}
            MenuListProps={{
              'aria-labelledby': "player-edit-pitch",
            }}
          >
            <MenuItem selected={currentPerformance ? currentPerformance.pitch == 3 : false} onClick={() => changeCurrentPitch(3)}>+3</MenuItem>
            <MenuItem selected={currentPerformance ? currentPerformance.pitch == 2 : false} onClick={() => changeCurrentPitch(2)}>+2</MenuItem>
            <MenuItem selected={currentPerformance ? currentPerformance.pitch == 1 : false} onClick={() => changeCurrentPitch(1)}>+1</MenuItem>
            <MenuItem selected={currentPerformance ? currentPerformance.pitch == 0 : false} onClick={() => changeCurrentPitch(0)}>0</MenuItem>
            <MenuItem selected={currentPerformance ? currentPerformance.pitch == -1 : false} onClick={() => changeCurrentPitch(-1)}>-1</MenuItem>
            <MenuItem selected={currentPerformance ? currentPerformance.pitch == -2 : false} onClick={() => changeCurrentPitch(-2)}>-2</MenuItem>
            <MenuItem selected={currentPerformance ? currentPerformance.pitch == -3 : false} onClick={() => changeCurrentPitch(-3)}>-3</MenuItem>
          </Menu>
          <Popover
            open={openAudioPopover}
            anchorEl={anchorAudioEl}
            onClose={handleCloseAudio}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}

          >
            <div className="muvika-player-volume-bar">
              <LinearProgressWithLabel currentTime={Math.round(playerStore.getState().currentVolume.currentVolume * 100) + "%"} value={playerStore.getState().currentVolume.currentVolume * 100} length={""} onProgressClick={handleVolumeClick} />
            </div>
          </Popover>
        </div>;
      } else {
        return <div style={{ textAlign: "center" }}>
          <span>
            {TR.ss_no_valid_subscription}
          </span>
        </div>;
      }
    }
  };

  const fullscreenInfo = () => {
    if (isPossiblyIPad()) {
      return TR.cm_mac_ipad_fullscreen;
    } else if (isChromecast()) {
      return TR.cm_chromebook_fullscreen;
    } else {
      return TR.cm_press_f11_for_fullscreen;
    }
  };

  return (
    <div className={props.className} id={props.id} style={props.style}>
      <InfoDialog open={isExternalInfoDialogOpen} onClose={handleCloseExternalInfoDialog} title={""} text={"<p>" + TR.cm_ext_screen_button_info_1 + "</p><p>" + TR.cm_ext_screen_button_info_2 + "</p>"} />
      <InfoDialog open={isFullscreenInfoDialogOpen} onClose={handleCloseFullscreenInfoDialog} title={""} text={fullscreenInfo()} />
      <ExternalScreenMove open={isExternalScreenMoveOpen} onClose={handleCloseExternalScreenMove} onConfirmation={handleAlwaysMoveToExternalScreen} />
      {renderPlayerContainer()}
    </div>
  );
}

export default Player;